import {mapGetters} from 'vuex';

const prakerjaFilterMixin = {
  computed: {
    ...mapGetters(['getPreviousPage']),
  },
  methods: {
    onClose() {
      if (this.getPreviousPage?.name && this.getPreviousPage?.name !== 'landing') {
        return this.$router.go(-1);
      }

      const parentRouteName = this.$route.matched?.[0]?.name;

      // Fix for BlSheetChildPage that has overflow: hidden when from landing page
      document.body.style.overflow = 'auto';

      if (parentRouteName === 'search') {
        this.$router.push({name: 'search', query: this.$route.query});
      } else if (parentRouteName === 'merchant') {
        this.$router.push({
          name: 'merchant',
          params: {id: this.$route.params.id},
          query: this.$route.query,
        });
      }
    },
  },
};

export default prakerjaFilterMixin;
